import React, { FC, ReactNode, useEffect, useState } from 'react'

import { useRunCallbackOnEnteringViewport } from '@smarty-nx/code-utils'
import cn from 'classnames'
import { Swiper as SwiperClass } from 'swiper/types'

import { Slider, ThisPlanIncludes } from './_parts'
import classes from './plans-carousel.module.scss'
import {
  triggerModuleLoadEvent2,
  triggerProductViewEvent,
} from '../../../utils/dataLayer'
import { buildAssetsProductsProps } from '../../../utils/dmpgAttributes'
import { PlanDataAndMeta } from '../../../utils/plans.types'

interface PlansCarouselProps {
  title: string
  heading?: ReactNode
  list: PlanDataAndMeta[]
  dataTestId?: string
  moduleId: string
  defaultPosition: number
}

export const PlansCarousel: FC<PlansCarouselProps> = ({
  title,
  list,
  heading,
  dataTestId,
  moduleId,
  defaultPosition = 0,
}) => {
  const [plan, setPlan] = useState<PlanDataAndMeta | undefined>(undefined)
  const [isReady, setIsReady] = useState(false)

  const ref = useRunCallbackOnEnteringViewport(() => {
    triggerModuleLoadEvent2(moduleId)
  })

  const handleUpdateThisPlanIncludes = ({ realIndex }: SwiperClass) => {
    setPlan(list[realIndex])
  }

  useEffect(() => {
    if (plan) {
      const product = buildAssetsProductsProps(plan).products[0]
      if (product?.id && product?.name) {
        triggerProductViewEvent(
          product as { id: string; name: string; category: string }
        )
      }
    }
  }, [plan])

  return (
    <>
      <div className={cn(classes.fadeWrapper, { [classes.ready]: isReady })}>
        <div
          ref={list.length > 0 ? ref : null}
          className={cn('redesign-container', classes.container)}
        >
          <div className={classes.title}>{title}</div>
          {heading}
        </div>

        <Slider
          list={list}
          onAfterInit={handleUpdateThisPlanIncludes}
          onSlideChange={handleUpdateThisPlanIncludes}
          onReady={() => setIsReady(true)}
          dataTestId={dataTestId}
          defaultPosition={defaultPosition}
        />
      </div>

      {plan && (
        <div className={classes.includes}>
          <ThisPlanIncludes selectedPlan={plan} />
        </div>
      )}
    </>
  )
}
